import { Link } from 'react-router-dom';

const benefits = [
  {
    icon: 'ri-vip-crown-line',
    title: '独家内容',
    desc: '会员专属原创剧集、精品短剧，提前48小时观看',
  },
  {
    icon: 'ri-4k-line',
    title: '超清画质',
    desc: '4K超高清画质 + 杜比全景声，影院级视听享受',
  },
  {
    icon: 'ri-download-line',
    title: '离线缓存',
    desc: '支持内容离线下载，随时随地畅享精彩',
  },
  {
    icon: 'ri-user-star-line',
    title: '专属特权',
    desc: '线上见面会、幕后花絮、投票决定未来内容方向',
  },
];

export default function MembershipSection() {
  return (
    <section className="py-10 md:py-14 bg-secondary-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-vip-crown-fill"></i> 会员专属
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            加入蜜桃传媒会员
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            解锁更多精品内容与专属权益，开启全新娱乐旅程
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 mb-10">
          {benefits.map((item, i) => (
            <div key={i} className="flex flex-col items-center text-center p-6 rounded-lg bg-background-50 border border-background-200/70">
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 mb-4">
                <i className={`${item.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/members"
            className="whitespace-nowrap px-8 py-3 rounded-md bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-600 transition-colors duration-200 cursor-pointer"
          >
            立即加入会员
          </Link>
          <Link
            to="/about"
            className="whitespace-nowrap px-6 py-3 rounded-md text-sm font-medium text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
          >
            了解更多权益 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}